var _rect, _rect2, _rect3, _text, _text2, _rect4, _rect5, _rect6, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    rx: 16,
    fill: "#eff6ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 60,
    width: 110,
    height: 160,
    rx: 14,
    fill: "white",
    stroke: "#3b82f6",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 85,
    width: 70,
    height: 45,
    rx: 7,
    fill: "#dbeafe"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 116,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 22,
    fontWeight: "bold",
    fill: "#2563eb",
    opacity: 0.8
  }, "120")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 132,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 9,
    fill: "#3b82f6",
    opacity: 0.5
  }, "mg/dL")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 145,
    width: 56,
    height: 13,
    rx: 4,
    fill: "#3b82f6",
    opacity: 0.12
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 172,
    y: 166,
    width: 56,
    height: 13,
    rx: 4,
    fill: "#3b82f6",
    opacity: 0.08
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 220,
    width: 16,
    height: 30,
    rx: 3,
    fill: "#60a5fa",
    opacity: 0.25
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 274,
    textAnchor: "middle",
    fontFamily: "'Segoe UI',Arial,sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#1e40af"
  }, "Diyabet")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/diabetes.b99ff6bc7479a7d5697ba0af0499a1ff.svg";
export { ForwardRef as ReactComponent };